import axios from 'axios'

const baseURL = process.env.REACT_APP_BACKEND_API

localStorage.setItem('base', baseURL)

const apinode = axios.create({
  baseURL,
  timeout: 1000 * 60 * 15,
})

export default apinode
